export default {
  'Custom': 'Benutzerdefiniert',
  'Original': 'Original',
}